import { usePwaState, useT } from '../hooks';
import { useServices } from '../services';

/** New-version and offline-ready notices from the service worker. */
export function UpdatePrompt() {
  const t = useT();
  const { pwa } = useServices();
  const { needRefresh, offlineReady } = usePwaState();
  return (
    <div role="status" aria-live="polite" className={needRefresh || offlineReady ? 'banner banner--info' : 'visually-hidden'}>
      {needRefresh ? (
        <>
          <span>{t('operator.pwa.updateAvailable')}</span>
          <button type="button" className="button button--primary" onClick={() => void pwa.update()}>
            {t('operator.pwa.reload')}
          </button>
        </>
      ) : offlineReady ? (
        <>
          <span>{t('operator.pwa.offlineReady')}</span>
          <button type="button" className="button" onClick={pwa.dismiss}>
            {t('operator.pwa.dismiss')}
          </button>
        </>
      ) : null}
    </div>
  );
}
